import { linguaFormato } from '@/lib/fmt';
import type { BlockedFriendshipDTO } from '@/types/social';

/**
 * La pagina «Account bloccati» (punto 7 del ridisegno Amici, L-2418 (a)).
 *
 * Il path sta qui e non ripetuto: la riga in fondo al tab Amici (`Link`) e la rotta
 * (`router.tsx`) lo leggono dallo stesso posto, cosi' un refuso non produce un link morto
 * con la build verde. Il router vuole il path relativo, senza la barra iniziale.
 */
export const BLOCCATI_PATH = '/friends/blocked';
export const BLOCCATI_ROUTE = BLOCCATI_PATH.slice(1);

/**
 * La data del blocco come la legge la persona («12 set 2026»). `null` se il server non ha mandato
 * una data leggibile: la riga allora NON dice «Bloccato il Invalid Date», tace.
 */
export function dataDelBlocco(blockedAt: string | undefined, lingua: string | undefined): string | null {
  if (!blockedAt) return null;
  const d = new Date(blockedAt);
  if (Number.isNaN(d.getTime())) return null;
  try {
    return d.toLocaleDateString(lingua || linguaFormato(), { day: 'numeric', month: 'short', year: 'numeric' });
  } catch {
    // Un tag che il runtime non sa leggere lancia RangeError: meglio la data nel ripiego dell'app (`en`) che niente.
    return d.toLocaleDateString('en', { day: 'numeric', month: 'short', year: 'numeric' });
  }
}

/** Il nome da mostrare: quello del profilo, altrimenti l'id (come l'elenco dei messaggi). */
export const nomeBloccato = (b: Pick<BlockedFriendshipDTO, 'displayName' | 'friendUserId'>): string =>
  b.displayName?.trim() || b.friendUserId;
